import {
  type OverlayRouteId,
  normalizePathname,
  pathnameToOverlayRoute,
} from "@/lib/overlayRoutes";

export type ResolvedPublicPath =
  | { type: "home" }
  | { type: "overlay"; route: OverlayRouteId }
  | { type: "not-found" };

export function resolvePublicPath(pathname: string): ResolvedPublicPath {
  if (normalizePathname(pathname) === "/") {
    return { type: "home" };
  }

  const route = pathnameToOverlayRoute(pathname);
  if (route) {
    return { type: "overlay", route };
  }

  return { type: "not-found" };
}

export function isKnownPublicPath(pathname: string): boolean {
  return resolvePublicPath(pathname).type !== "not-found";
}
